/** Matches a raw i18n message key that reached the client unresolved, e.g. `boxhub.system.error.generic`. */
const MESSAGE_KEY_PATTERN = /^boxhub\.[\w.]+$/;

/**
 * Returns the message only when it is readable text. The backend resolves system messages via a
 * three-stage lookup whose last stage returns the technical key itself; showing that key would
 * expose internal key and constraint names, so it is dropped in favor of a generic text.
 *
 * @param message the message received from the server
 * @returns the message, or `undefined` when it is an unresolved message key
 */
export const displayableMessage = (message?: string): string | undefined =>
    message != null && !MESSAGE_KEY_PATTERN.test(message) ? message : undefined;
